<template>
      <div class="card mb-3">
        <div class="card-header">
          <i class="fa fa-user-circle-o"></i> {{ $t('user.title') }}
          <createButton name="users_create" :title="$t('user.create.title')"></createButton>
        </div>
        <div class="card-body">
          <errorMessage v-bind:message="error"></errorMessage>
          <div class="table-responsive">
            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>{{ $t('user.form.name') }}</th>
                  <th>{{ $t('user.form.surname') }}</th>
                  <th>{{ $t('user.form.emailAddress') }}</th>
                  <th class="drop-down-filter">{{ $t('user.form.roles') }}</th>
                  <th class="date-range-filter">{{ $t('user.lastLogin') }}</th>
                  <th class="date-range-filter">{{ $t('user.form.creationDate') }}
                  <th class="no-filter">{{ $t('user.form.status') }}</th>
                  <th class="hidden no-filter">{{ $t('user.form.phone') }}</th>
                  <th class="no-sort no-filter" width=100 v-if="canCreate || canDelete">&nbsp;</th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>{{ $t('user.form.name') }}</th>
                  <th>{{ $t('user.form.surname') }}</th>
                  <th>{{ $t('user.form.emailAddress') }}</th>
                  <th class="drop-down-filter">{{ $t('user.form.roles') }}</th>
                  <th>{{ $t('user.lastLogin') }}</th>
                  <th>{{ $t('user.form.creationDate') }}
                  <th class="no-filter"></th>
                  <th class="hidden no-filter">{{ $t('user.form.phone') }}</th>
                  <th class="no-sort no-filter" width=100 v-if="canCreate || canDelete">&nbsp;</th>
                </tr>
              </tfoot>
              <tbody>
                <tr v-for="user in users" :data-id="user.id" :key="user.id">
                  <td>{{user.firstName}}</td>
                  <td>{{user.lastName}}</td>
                  <td>
                    {{user.emailAddress}} <span v-if="user.emailAddress != user.userName"><br>
                    {{user.userName}}</span>
                  </td>
                  <td>
                    <span class=user v-for="roleName in user.roleNames" >
                      {{roleName.displayName}}
                    </span> 
                  </td>
                  <td>{{user.lastLoginTime | formatDate}}</td>
                  <td>{{user.creationTime | formatDate}}</td>
                  <td>
                    <i v-if="user.isActive" class="fa fa-lg fa-check toggle-active" aria-hidden="true" 
                       @click="deactivateUser(user.id)" :title="$t('user.form.deactivateUser')">
                      <span class="hidden">a</span>
                    </i>
                    <i v-if="!user.isActive" class="fa fa-lg fa-ban toggle-deactivated" aria-hidden="true" 
                        @click="activateUser(user.id)" :title="$t('user.form.activateUser')">
                      <span class="hidden">b</span>
                    </i>
                    <i v-if="!user.isEmailConfirmed" class="fa fa-lg fa-envelope-o" aria-hidden="true" :title="$t('user.form.emailNotConfirmed')">
                      <span class="hidden">b</span>
                    </i>
                  </td>
                  <td class="hidden">{{user.phoneNumber}}</td>
                  <td  class="no-sort" align=center v-if="canCreate || canDelete">
                    <a href="#" v-if="canCreate" v-on:click="editUser(user)">
                      <span class="fa fa-lg fa-pencil"></span>
                    </a>
                    &nbsp;
                    <a class="text-danger" v-if="canDelete" href="#" v-on:click="deleteUser(user.id)">
                      <span class="fa fa-lg fa-trash"></span>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
</template>

<script>
import {UserServiceClient} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import SearchMixin from '../../shared/Mixin/SearchMixin'
import moment from 'moment'

export default {
  name: 'Users',
  mixins: [SearchMixin],
  data() {
    return {
      users: [],
    }
  },
  created: function() {
    this.fetchData()
  },
  mounted: function() {},
  methods: {
    fetchData: function() {
      let userService = ServiceFactory.create(UserServiceClient)
      let self = this

      userService
        .getAll('', 0, 10000)
        .then(res => {
          self.users = res.items
          self.showDataTable()
        })
        .catch(err => {
          self.error = self.getErrorMessage(err)
        })
    },
    editUser: function(user) {
      this.$router.push({name: 'users_edit', params: {id: user.id}})
    },
    deactivateUser: function(id) {
      if (!this.canCreate) return

      swal({
        title: this.$i18n.t('user.deactivateWarning'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(confirm => {
        if (confirm) {
          let userService = ServiceFactory.create(UserServiceClient)
          userService
            .deactivate({id: id})
            .then(res => {
              this.fetchData()
            })
            .catch(err => {
              self.error = self.getErrorMessage(err)
            })
        }
      })
    },
    activateUser: function(id) {
      if (!this.canCreate) return

      swal({
        title: this.$i18n.t('user.activateWarning'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(confirm => {
        if (confirm) {
          let userService = ServiceFactory.create(UserServiceClient)
          userService
            .activate({id: id})
            .then(res => {
              this.fetchData()
            })
            .catch(err => {
              self.error = self.getErrorMessage(err)
            })
        }
      })
    },
    sendEmailConfirmation: function(user) {},
    deleteUser: function(id) {
      let service = ServiceFactory.create(UserServiceClient)
      this.processDelete(this, service, id, this.$i18n.t('user.user'))
    },
  },
  filters: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.toggle-active {
  color: #28a745;
  cursor: pointer;

  &:hover {
    color:#dc3545;

    &:before{
      content: "\F05E";
    }
  }
}

.toggle-deactivated {
  color:#dc3545;
  cursor: pointer;
  
  &:hover {
    color: #28a745;

    &:before{
      content: "\F00C";
    }
  }
}

.user ~ .user::before{
    content: ","
  }
</style>



// WEBPACK FOOTER //
// src/components/users/Users.vue